import { render } from "./LogoWall.vue?vue&type=template&id=4d4552f6"
import script from "./LogoWall.vue?vue&type=script&lang=js"
export * from "./LogoWall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/sections/LogoWall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d4552f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d4552f6', __exports__)) {
    api.reload('4d4552f6', __exports__)
  }
  
  module.hot.accept("./LogoWall.vue?vue&type=template&id=4d4552f6", () => {
    api.rerender('4d4552f6', render)
  })

}


export default __exports__